import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { clusterApiUrl } from '@solana/web3.js';

export const APP_SHORT_NAME = 'FG' as const;
export const APP_FULL_NAME = 'Frog Games' as const;
export const DEFAULT_LOCALE = 'en';
export const LOCALES = ['en'];

export const JWT_KEY = `${APP_SHORT_NAME}-passport`;

export const CONTACT_MAIL = 'contact@froggames.fun' as const;

export const BASE_URL =
  import.meta.env.VITE_BASE_URL ?? 'https://fr0g.vercel.com';

export const CLUSTER = (import.meta.env.VITE_CLUSTER ||
  WalletAdapterNetwork.Devnet) as WalletAdapterNetwork;

export const CLUSTER_URL =
  import.meta.env.VITE_CLUSTER_URL || clusterApiUrl(CLUSTER);

export const DEFAULT_PAGE_SIZE = 20;

export const API_URL = new URL(
  import.meta.env.VITE_API_URL || 'http://localhost:5173'
);

export const Videos = {
  stop: `/bet_stop.m3u8`,
  loading: `/loading.m3u8`,
} as const;

export const FG_TOKEN_ADDR =
  'Frog5N75hHEMSbAg9LgHxSv4QnTAR5DbTDFnD2vjLBEP' as const;
